<section class="p-3">

  <lib-dialog-header
    [titulok]="'Náhrada za predmet, opakovaný zápis' | translate"
    [predmetNazov]="predmet.predmetNazov"
    [predmetSkratka]="predmet.predmetSkratka"
  >
  </lib-dialog-header>

  <mat-dialog-content class="mat-typography p-1 p-sm-3">

    <div>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label i18n>Vyberte predmet</mat-label>
        <mat-select [(value)]="selectedId">
          @for (group of predmety; track group) {
            <mat-optgroup [label]="group.akRok">
              @for (p of group.predmety; track p) {
                <mat-option [value]="p.id">{{p.nazov}}</mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
      </mat-form-field>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
    <button mat-stroked-button (click)="save()">
      <span i18n>Uložiť</span>
    </button>
  </mat-dialog-actions>

</section>
